import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import PropTypes from 'prop-types';

const Match = props => {

    const { match, slug, urlAssets } = props;
    const { team1, score, team2 } = match;

    return (
        <section className="text-center">
            <article className="mt-3">
                <span className="text-team">{team1}</span>
                <span className="mx-2 score">{score}</span>
                <span className="text-team">{team2}</span>
            </article>
            <article className="">
                <LazyLoadImage
                    alt={team1}
                    className="img-fluid"
                    effect="blur"
                    src={`${urlAssets}/img/selecciones-datos/${slug}/clasificacion.png`}
                />
            </article>            
        </section>
    )
}

export default Match;

Match.propTypes = {
    match: PropTypes.object.isRequired,
    slug: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired    
}

